export enum CpoResetType {
  hard = 'Hard',
  soft = 'Soft'
}

export interface ChargingPayload {
  cpoCountryCode: string;
  cpoPartyId: string;
  newStatus: string;
  evseUid: string;
  owner?: string;
  locationId?: string;
  cpoConnectorId?: string;
}

export enum CpoConnectorStatus {
  start = 'START_SESSION',
  stop = 'STOP_SESSION',
  reserved = 'RESERVED',
  blocked = 'BLOCKED',
  unknown = 'UNKNOWN',
  planned = 'PLANNED',
  removed = 'REMOVED',
  out_of_order = 'OUTOFORDER'
}

export enum SESSION_DETAILS_STATUS {
  active = 'ACTIVE',
  completed = 'COMPLETED'
}
